import './visitor_access_display.less';

import PropTypes from 'prop-types';

import React from 'react';
import classNames from 'classnames';

import Page from 'zoomforth_zf/models/page.js';

import { GlobeIcon, LockIcon } from 'zoomforth_component_lib/app_modern_icons.jsx';

import { 
  VISITOR_ACCESS_DESCRIPTION_PUBLIC,
  VISITOR_ACCESS_DESCRIPTION_PASSWORD,
  VISITOR_ACCESS_DESCRIPTION_EMAIL,
  VISITOR_ACCESS_DESCRIPTION_SSO } from 'zoomforth_shared_management/const/visitor_access_settings.js';


import userStore from 'zoomforth_zf/appglobals/user.js';


const ValidEmailsList = ({ permissions }) => {
  if (permissions === null) {
    return (
      <div className="valid-email-list">
        All users on this Zoomforth Account
      </div>
    );
  }

  // Build a str representation of a list of permission strings such that the
  // first two are show (if there are at least two) and anything else is
  // truncated to "+ X more..."
  const destructureArray = (permission) => {
    const [ first, second, ...rest ] = permission;
    return `${first}${second ? ', ' + second : ''}${rest.length > 0 ? ' + ' + rest.length + ' more...' : ''}`;
  };

  const emails = permissions.emails;
  const domains = permissions.domains.map((domain) => `Emails with @${domain}`);

  let output = '';
  if (emails.length === 0 && domains.length === 0) {
    output = 'All users on this Zoomforth Account';
  } else if (emails.length === 0 && domains.length > 0) {
    output = destructureArray(domains);
  } else if (emails.length > 0 && domains.length === 0) {
    output = destructureArray(emails);
  } else if (emails.length > 0 && domains.length > 0) {
    output = destructureArray(emails.concat(domains));
  }

  return (
    <div className="valid-email-list">
      { output }
    </div>
  );
};

const VisitorAccessDisplay = ({ showAuthorizedEmails, onVisitorAccessSettingsView, ...props })=> {

  const EditVisitorAccessLink = ({ children }) => (
    !userStore.get().getPermissions().canChangeVisitorAccessSettings(props.page) 
      ? null 
      : <span className="edit-link">
          <a onClick={onVisitorAccessSettingsView}>
            { children }
          </a>
        </span>
  );

  if (props.page.isPublic()) {
    return (
      <div className="visitor-access-display">
        <div className="visitor-access-header">
          <EditVisitorAccessLink>
            <GlobeIcon /> {VISITOR_ACCESS_DESCRIPTION_PUBLIC} <strong>></strong>
          </EditVisitorAccessLink>
        </div>
      </div>
    );
  }

  if (props.page.usesPasswordPrivacy()) {
    return (
      <div className="visitor-access-display">
        <div className="visitor-access-header">
          <EditVisitorAccessLink>
            <LockIcon /> {VISITOR_ACCESS_DESCRIPTION_PASSWORD} <strong>></strong>
          </EditVisitorAccessLink>
        </div>
      </div>
    );
  }

  if (props.page.usesSAMLPrivacy()) {
    return (
      <div className="visitor-access-display">
        <div className="visitor-access-header">
          <EditVisitorAccessLink>
            <LockIcon /> {VISITOR_ACCESS_DESCRIPTION_SSO} <strong>></strong>
          </EditVisitorAccessLink>
        </div>
      </div>
    );
  }
  
  return (
    <div className={classNames('visitor-access-display', {'scrolling':props.scrolling}, props.className)} >

      <div className="visitor-access-header">
        <EditVisitorAccessLink>
          <LockIcon /> {VISITOR_ACCESS_DESCRIPTION_EMAIL} <strong>></strong>
        </EditVisitorAccessLink>

        { showAuthorizedEmails && <ValidEmailsList permissions={props.page.get('permissions')} /> }
      </div>

    </div>
  );
};

VisitorAccessDisplay.displayName = 'PagePrivacyDisplay';

VisitorAccessDisplay.defaultProps = {
  scrolling: false,
  showAuthorizedEmails: true
};

VisitorAccessDisplay.propTypes = {
  scrolling: PropTypes.bool,
  showAuthorizedEmails: PropTypes.bool,
  page: PropTypes.instanceOf(Page).isRequired,
  onVisitorAccessSettingsView: PropTypes.func.isRequired
};

export default VisitorAccessDisplay;
